import Navigation from 'libs/classes/navigation';
import utils from 'libs/utils';

function getNewNavigationItem () {
  return {
    name: utils.getRandomID(),
    close: null
  };
}
export default {
  data() {
    return {
      modalOpen: false,
      navigationItem: getNewNavigationItem()
    };
  },
  created() {
    this.navigationItem.close = () => this.close();
  },
  methods: {
    showModal() {
      this.modalOpen = true;
      this.addNavigationItem();
    },
    close() {
      this.modalOpen = false;
      this.removeNavigationItem();
    },
    addNavigationItem () {
      Navigation.addItem(this.navigationItem);
    },
    removeNavigationItem () {
      Navigation.removeItem(this.navigationItem);
    }
  }
};
